import React, { useEffect, createElement } from 'react';
import AdvertorialGlpInvestigationD from '../components/AdvertorialGlpInvestigationD';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// Declare fbq for TypeScript
declare global {
  interface Window {
    fbq: any;
  }
}
export function GlpInvestigationDPage() {
  useEffect(() => {
    // Initialize Facebook Pixel with safety checks
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      // Safety check: if no script elements exist, append to head instead
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize with your NEW Pixel ID for Adv2
    window.fbq('init', '9567705179928833');
    window.fbq('track', 'PageView');
    // Track ViewContent for this advertorial
    window.fbq('track', 'ViewContent', {
      content_name: 'Ozempic Depression Investigation',
      content_category: 'Health',
      content_type: 'article'
    });
    // Store fbclid in localStorage if present in URL
    const params = new URLSearchParams(window.location.search);
    const fbclid = params.get('fbclid');
    if (fbclid) {
      localStorage.setItem('fbclid', fbclid);
    }
    // Set up scroll depth tracking
    let tracked50 = false;
    let tracked90 = false;
    const handleScroll = () => {
      const scrollPercent = window.scrollY / (document.body.scrollHeight - window.innerHeight) * 100;
      if (!tracked50 && scrollPercent > 50) {
        window.fbq('trackCustom', 'ReadHalfArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked50 = true;
      }
      if (!tracked90 && scrollPercent > 90) {
        window.fbq('trackCustom', 'ReadFullArticle', {
          article_title: 'Ozempic Depression Investigation'
        });
        tracked90 = true;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return <HelmetProvider data-id="element-18585" data-mp="3q3jt3px2efzt">
      <div className="w-full min-h-screen bg-gray-100" data-id="element-18586" data-mp="3q41ypd5ma6ke">
        <Helmet data-id="element-18587" data-mp="3q1fr5diq7r26">
          <title data-id="element-18588" data-mp="8miqrshelw5k">
            After 30 Years of Practice, I Stopped Prescribing Semaglutide
          </title>
          <meta property="og:title" content="After 30 Years of Practice, I Stopped Prescribing Semaglutide" data-id="element-18589" data-mp="3n5w4lkajksf" />
          <meta property="og:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18590" data-mp="hmp49ed3qw4q" />
          <meta property="og:type" content="article" data-id="element-18591" data-mp="119s92qhkm55g" />
          <meta property="og:url" content={window.location.href} data-id="element-18592" data-mp="118h44nce2rcr" />
          <meta property="og:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18593" data-mp="n8fv2klz0dm7" />
          <meta property="og:image:width" content="1200" data-id="element-18594" data-mp="saeyfuhpnaj5" />
          <meta property="og:image:height" content="630" data-id="element-18595" data-mp="diw9362yo3n4" />
          <meta property="og:site_name" content="Health Investigation Series" data-id="element-18596" data-mp="ia4jo5g11v1v" />
          <meta name="twitter:card" content="summary_large_image" data-id="element-18597" data-mp="ic8y3hbjycge" />
          <meta name="twitter:title" content="After 30 Years of Practice, I Stopped Prescribing Semaglutide" data-id="element-18598" data-mp="4kkmrg94ns0h" />
          <meta name="twitter:description" content="After three decades in endocrinology, I've prescribed thousands of medications. But when patients on Ozempic started reporting severe depression—and regulatory agencies ignored it—I spent 16 months and my own money investigating." data-id="element-18599" data-mp="8kuscrt0cget" />
          <meta name="twitter:url" content={window.location.href} data-id="element-18600" data-mp="11w1bgvxqgfdn" />
          <meta name="twitter:image" content="https://uploadthingy.s3.us-west-1.amazonaws.com/rj5HPkWXSP8komhpUDQJCG/6OUBdNn4rvjDcxkk8ToP9.jpg" data-id="element-18601" data-mp="xv7n61gdoyk8" />
        </Helmet>
        <AdvertorialGlpInvestigationD data-id="element-18602" data-mp="t2o78xu7xrc9" />
      </div>
    </HelmetProvider>;
}